
export const bindCheckboxesGroup = (parent, children) => {
    if (!parent || children.length === 0) {
        return;
    }

    const updateCheckboxesState = function () {
        parent.checked = Array.prototype.every.call(children, el => el.checked);
        parent.indeterminate = !parent.checked && Array.prototype.some.call(children, el => el.checked);
    };

    const onChangeParent = () => {
        for (let child of children) {
            child.checked = parent.checked;
        }
    };

    // Bind events
    parent.addEventListener('change', onChangeParent);
    for (let child of children) {
        child?.addEventListener('change', updateCheckboxesState);
    }

    // Destruktor
    return () => {
        parent.removeEventListener('change', onChangeParent);
        for (let child of children) {
            child?.removeEventListener('change', updateCheckboxesState);
        }
    };
};
